module.exports = __webpack_public_path__ + "static/media/logo_GMX.664ce407.svg";